import { render, staticRenderFns } from "./ParentCompanyAdmin.vue?vue&type=template&id=49516411&"
import script from "./ParentCompanyAdmin.vue?vue&type=script&lang=js&"
export * from "./ParentCompanyAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports